"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _utils = require("./utils");

var _labelLike = _interopRequireDefault(require("./label-like"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _input = _interopRequireDefault(require("./input.css"));

var _excluded = ["id", "data-testid", "label", "className", "inputClassName", "labelClassName", "name", "applyLabel", "autoComplete", "onApply", "theme", "type", "onClear", "showClearBtn", "persistInCookie", "validateFromLength", "formatValue", "validation", "defaultValue"];
var validationFnsMap = {
  minValue: function minValue(value, options) {
    return value >= options.value;
  },
  maxValue: function maxValue(value, options) {
    return value <= options.value;
  },
  minLength: function minLength(value, options) {
    return value.length >= options.value;
  },
  maxLength: function maxLength(value, options) {
    return value.length <= options.value;
  },
  pattern: function pattern(value, options) {
    var regex = options.value instanceof RegExp ? options.value : new RegExp(options.value);
    return regex.test(value);
  }
};

var getErrors = function getErrors(value, validation) {
  return Object.entries(validation).map(function (_ref) {
    var key = _ref[0],
        options = _ref[1];

    // Allow custom functions
    if (key === 'custom' && typeof options.fn === 'function') {
      return !options.fn(value, options) ? options.message : false;
    } // Use standard predefined ones


    return validationFnsMap[key] && !validationFnsMap[key](value, options) ? options.message : false;
  }).filter(Boolean);
};

var Input = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Input, _React$PureComponent);

  function Input(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    var value = (0, _utils.getDefaultValue)(props.name, props.defaultValue);
    _this.state = {
      applied: Boolean(value),
      errors: [],
      value: value,
      focused: false
    };
    _this.validate = _this.validate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleApply = _this.handleApply.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var value = this.state.value;

    if (value) {
      this.validate(true);
    }
  };

  _proto.handleFocus = function handleFocus() {
    this.setState({
      focused: true,
      value: ''
    });
  };

  _proto.handleBlur = function handleBlur() {
    this.setState({
      focused: false
    });
  };

  _proto.handleApply = function handleApply() {
    var _this2 = this;

    var _this$props = this.props,
        name = _this$props.name,
        persistInCookie = _this$props.persistInCookie,
        onApply = _this$props.onApply;
    var value = this.state.value;

    if (persistInCookie) {
      (0, _utils.cookie)(name, value);
    }

    this.setState({
      applied: true
    }, function () {
      if (onApply) {
        _this2.validate(true);

        onApply(value);
      }
    });
  };

  _proto.handleClear = function handleClear() {
    var _this$props2 = this.props,
        name = _this$props2.name,
        persistInCookie = _this$props2.persistInCookie,
        onClear = _this$props2.onClear,
        onChange = _this$props2.onChange;

    if (persistInCookie) {
      (0, _utils.cookie)(name, null);
    }

    this.setState({
      applied: false,
      value: '',
      errors: []
    }, function () {
      var event = {
        target: {
          name: name,
          value: ''
        }
      };
      onChange(event);
      onClear();
    });
  };

  _proto.handleChange = function handleChange(event) {
    var _this3 = this;

    var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        onApply = _this$props3.onApply,
        name = _this$props3.name,
        persistInCookie = _this$props3.persistInCookie;
    var value = event.target.value;
    onChange(event);

    if (persistInCookie && !onApply) {
      (0, _utils.cookie)(name, value);
    }

    if (!value) {
      this.setState({
        errors: []
      });
      (0, _utils.cookie)(name, null);
    }

    this.setState({
      applied: false,
      value: value
    }, function () {
      if (!onApply) {
        _this3.validate(true);
      }
    });
  };

  _proto.handleKeyPress = function handleKeyPress(e) {
    var isEnterKey = e.which === 13;

    if (isEnterKey) {
      this.handleApply();
    }
  };

  _proto.validate = function validate(calledInternally) {
    if (calledInternally === void 0) {
      calledInternally = false;
    }

    var value = this.state.value;
    var _this$props4 = this.props,
        lazyValidation = _this$props4.lazyValidation,
        validation = _this$props4.validation,
        validateFromLength = _this$props4.validateFromLength,
        onError = _this$props4.onError;
    var hasMinLength = typeof validateFromLength !== 'number' ? true : value.length >= validateFromLength;

    if (validation) {
      if (!hasMinLength) {
        this.setState({
          errors: []
        });
        onError([]);
      } else if (!calledInternally && lazyValidation || calledInternally && !lazyValidation) {
        var errors = getErrors(value, validation);
        onError(errors);
        this.setState({
          errors: errors
        });
      }
    }
  };

  _proto.hasValue = function hasValue() {
    var formatValue = this.props.formatValue;
    var _this$state = this.state,
        value = _this$state.value,
        focused = _this$state.focused;

    if (!focused) {
      return formatValue(value);
    }

    return value || typeof value === 'number' && value === 0;
  };

  _proto.hasErrors = function hasErrors() {
    var errors = this.state.errors;
    return Boolean(errors.length);
  };

  _proto.isClearVisible = function isClearVisible() {
    var _this$state2 = this.state,
        applied = _this$state2.applied,
        value = _this$state2.value;
    var _this$props5 = this.props,
        onApply = _this$props5.onApply,
        showClearBtn = _this$props5.showClearBtn;

    if (typeof showClearBtn === 'boolean') {
      return showClearBtn && value;
    }

    return value && (applied || typeof onApply !== 'function');
  };

  _proto.render = function render() {
    var _clsx, _clsx2;

    var _this$props6 = this.props,
        id = _this$props6.id,
        testID = _this$props6['data-testid'],
        label = _this$props6.label,
        className = _this$props6.className,
        inputClassName = _this$props6.inputClassName,
        labelClassName = _this$props6.labelClassName,
        name = _this$props6.name,
        applyLabel = _this$props6.applyLabel,
        autoComplete = _this$props6.autoComplete,
        onApply = _this$props6.onApply,
        theme = _this$props6.theme,
        type = _this$props6.type,
        onClear = _this$props6.onClear,
        showClearBtn = _this$props6.showClearBtn,
        persistInCookie = _this$props6.persistInCookie,
        validateFromLength = _this$props6.validateFromLength,
        formatValue = _this$props6.formatValue,
        validation = _this$props6.validation,
        defaultValue = _this$props6.defaultValue,
        inputProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, _excluded);
    var _this$state3 = this.state,
        applied = _this$state3.applied,
        errors = _this$state3.errors,
        value = _this$state3.value,
        focused = _this$state3.focused;
    var isClearBtnVisible = this.isClearVisible();
    var isApplyBtnVisible = this.hasValue() && typeof onApply === 'function' && !applied;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(_input["default"].inputContainer, 'input-wrapper', className)
    }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
      "data-testid": testID,
      id: id || name,
      autoComplete: autoComplete,
      className: (0, _clsx3["default"])(inputClassName, _input["default"].input, (_clsx = {}, _clsx[_input["default"].inputError] = this.hasErrors(), _clsx)),
      name: name,
      onChange: this.handleChange,
      onKeyPress: this.handleKeyPress,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      value: focused ? value : formatValue(value),
      type: type,
      "aria-label": name
    })), label && /*#__PURE__*/_react["default"].createElement(_labelLike["default"], {
      htmlFor: id || name,
      className: (0, _clsx3["default"])(_input["default"].label, labelClassName, (_clsx2 = {}, _clsx2[_input["default"].focus] = this.hasValue(), _clsx2))
    }, label), this.hasErrors() && errors.map(function (error) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: error,
        theme: theme,
        message: error
      });
    }), isApplyBtnVisible && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx3["default"])(theme.grey, _input["default"].applyBtn),
      type: "button",
      onClick: this.handleApply
    }, applyLabel), isClearBtnVisible && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx3["default"])(theme.grey, _input["default"].clearBtn),
      "aria-label": "Clear button",
      type: "button",
      onClick: this.handleClear
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.mmcIconClose
    })));
  };

  return Input;
}(_react["default"].PureComponent);

exports["default"] = Input;
Input.defaultProps = {
  applyLabel: 'Apply',
  showClearBtn: false,
  autoComplete: 'off',
  formatValue: function formatValue(value) {
    return value;
  },
  onChange: function onChange() {
    return undefined;
  },
  onClear: function onClear() {
    return undefined;
  },
  onError: function onError() {
    return undefined;
  }
};